import type {
  ThemeBreakpoints,
  ThemeBreakpointScreenSize,
} from "./theme-breakpoints.type";

import { Grid } from "antd";

import { getActiveBreakpoint } from "./theme-breakpoints.helper";

export const useThemeBreakpoints = () => {
  const antBp = Grid.useBreakpoint();

  const breakpoints: ThemeBreakpoints = {
    xs: true,
    sm: antBp.sm ?? false,
    md: antBp.md ?? false,
    lg: antBp.lg ?? false,
    xl: antBp.xl ?? false,
    xxl: antBp.xxl ?? false,
    xxxl: antBp.xxxl ?? false,
  };

  const activeBreakpoint = getActiveBreakpoint(breakpoints);

  const isXs = activeBreakpoint === "xs";
  const isLargeScreen = breakpoints.xxxl || breakpoints.xxl || breakpoints.xl;
  const isSmallScreen = !isLargeScreen;

  const screenSize: ThemeBreakpointScreenSize = isLargeScreen
    ? "large"
    : "small";

  return {
    ...breakpoints,
    activeBreakpoint,
    isXs,
    isLargeScreen,
    isSmallScreen,
    screenSize,
  };
};
